var React = require('react');
import { Link, browserHistory } from 'react-router';
var CollectionRes = require('../../resources/collection');
var ConceptRes = require('../../resources/concept');
var Auth = require("../../resources/auth");
import CircularProgress from 'material-ui/CircularProgress';
import '../../css/components/Collections/collections.css';
import { Pager } from 'react-bootstrap';
import ExamsTable from './ExamsTable';
import notification from '../Modal/notification';
import '../../css/components/Exam/processing.css';

const ADMIN_STATUSES = [{
  title: 'Recommended',
  value: ['to_be_reviewed'],
  actions: ['edit', 'publish', 'reject'],
  count: '-',
  notes: []
},{
  title: 'Published',
  value: ['published'],
  actions: ['view', 'new-ver','processing','archived'],
  count: '-',
  notes: []
},{
  title: 'Rejected',
  value: ['rejected'],
  actions: ['view', 'recover'],
  count: '-',
  notes: []
}]

const ITEM_LIMIT = 20;

var ExamsManagement = React.createClass({

	retrieveMockExams: function(callback) {
		callback = callback || function(){};
		var _this = this;
		var currentPager = this.state.currentPager;
		var options = {};
		options.skip = ITEM_LIMIT * (currentPager - 1);
		options.limit = ITEM_LIMIT;
		options.sort = this.state.sort || "-dateModified";
		options.conditions = {};
		options.conditions.status = {
			"$in": this.state.currentMode.value
		}

	    // get mock-exams with this condition 
	    options.conditions.type = 'MOCK_EXAM';
	    options.include = "kquestion-required";
	    // we use Collection resource to load mock-exam because they have same model
	    // mock-exam and collection are distinguided by type above 
	    CollectionRes.retrieveCollections(options, function(err, res) {
	    	console.log('res', res)
	    	for(var i in res){
	    		var countMCQ = 0;
	    		var countSS = 0;
	    		var countLS = 0;
	    		var countMCQScore = 0;
	    		var countSSScore = 0;
	    		var countLSScore = 0;
	    		for(var j in res[i].questions){
	    			if(res[i].questions[j].kquestion.type==11){
	    				countMCQ++;
	    				countMCQScore +=res[i].questions[j].numPoints;
	    			}
	    			if(res[i].questions[j].kquestion.type==21){
	    				countSS++;
	    				countSSScore +=res[i].questions[j].numPoints;
	    			}
	    			if(res[i].questions[j].kquestion.type==22){
	    				countLS++;
	    				countLSScore +=res[i].questions[j].numPoints;
	    			}
	    		}
	    		res[i].MCQ = countMCQ;
	    		res[i].SS = countSS;
	    		res[i].LS = countLS;
	    		res[i].total = countMCQ + countSS + countLS;
	    		res[i].MCQScore = countMCQScore;
	    		res[i].SSScore = countSSScore;
	    		res[i].LSScore = countLSScore;
	    		res[i].totalScore = countMCQScore + countSSScore + countLSScore;
	    	}

	    	_this.setState({
	    		isLoading: false,
	    		collectionData: (!err && res) ? res: [{}]
	    	}, function() {
	    		return callback(err, res);
	    	});
	    })
  	},
 
  	retrieveConceptsMap: function(callback) {
  		callback = callback || function(){};
  		var _this = this;
  		ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
  			_this.setState({
  				conceptsMap: conceptsMap
  			})
  			return callback(err, conceptsMap);
	    })
  	},

  	retrieveUserCourses: function(callback) {
  		callback = callback || function(){};
  		var _this = this;
  		ConceptRes.retrieveUserCourses(function(err, courses) {
  			var coursesMap = {};
  			courses.map(function(course, index) {
  				coursesMap[course._id] = course.title;
  			});
  			_this.setState({
  				userCourses: coursesMap
  			})
  			return callback(err, coursesMap);
	    })
  	},
  	recoverCollection: function(collection){
					collection.status = "to_be_reviewed";
	        var _this = this;
	        CollectionRes.updateCollectionOnly(collection, function(err, data) {
	            if (err) {
	                return notification.open({
	                    message: 'Error',
	                    description: 'Cannot recover Mock Exam. Please try again'
	                })
	            }
	            notification.open({
	                message: 'Success',
	                description: "Mock Exam has been recovered!"
	            })
	           _this.countMockExamsInModeAll();
	        });
  	},
  	 publishCollection: function(collection) {
					collection.status = "published";
					collection.instance_status = "published";
	        var _this = this;
	        CollectionRes.updateCollectionOnly(collection, function(err, data) {
	            if (err) {
	                return notification.open({
	                    message: 'Error',
	                    description: 'Cannot published Mock Exam. Please try again'
	                })
	            }
	            notification.open({
	                message: 'Success',
	                description: "Mock Exam has been published!"
	            })
	           _this.countMockExamsInModeAll();
	        });
	    },
	    rejectCollection: function(collection) {
									if(collection.instance_status === 'processing') {
										collection.status = 'deleted'
									}
	                else {
										collection.status = "rejected";
									}
	                var _this = this;
	                CollectionRes.updateCollectionOnly(collection, function(err, data) {
	                    if (err) {
	                        return notification.open({
	                            message: 'Error',
	                            description: 'Cannot rejected Mock Exam. Please try again'
	                        })
	                    }
	                    notification.open({
	                        message: 'Success',
	                        description: "Mock Exam has been rejected!"
	                    })
	                   _this.countMockExamsInModeAll();
	                });
			},
		createNewVerCollection: function(collection){
			if(!this.state.isUpdating){
				this.setState({
					isUpdating: true
				})
				collection.instance_status = "processing";
				var _this = this;
				CollectionRes.updateCollectionOnly(collection, function(err, data) {
						_this.setState({
							isUpdating: false
						})
					 if (err) {
							 return notification.open({
									 message: 'Error',
									 description: 'Cannot create new version Mock Exam. Please try again'
							 })
					 }
					 notification.open({
							 message: 'Success',
							 description: "Mock Exam has been in processing mode!"
					 })
					_this.countMockExamsInModeAll();
				});
			}	
		},
  	countMockExamsInMode: function(mode, callback) {
  		var _this = this;
  		callback = callback || function(){};
  		mode.count = '-';
  		var conditions = {
  			status: {
  				'$in': mode.value
  			}
  		}

  		// get mock-exams with this condition 
  		conditions.type = 'MOCK_EXAM';

		// conditions.creator = Auth.getCurrentUser()._id;
	    
	    // we use Collection resource to load mock-exam because they have same model
	    // mock-exam and collection are distinguided by type above 
    	CollectionRes.countCollection(conditions, function(err, res) {
    		if (!err && res) mode.count = res.count;
    		else mode.count = 'No data';
    		return callback();
    	})
  	},
  
  	changeStatusMode: function(mode) {
    	this.setState({
      		currentMode: mode,
					collectionData: [],
					isLoading: true,
					currentPager: 1
    	}, function() {
		this.retrieveMockExams();
    	});
    },

    onSortChange: function(newSort) {
    	this.setState({
    		sort: newSort,
    		collectionData: [],
    		isLoading: true,
    		currentPager: 1,
    	}, () => {
    		this.retrieveMockExams();
    	});
    },
    	
		getInitialState: function() {
	    return {
	    	currentMode: {},
	    	collectionData: [],
	    	isLoading: true,
	    	conceptsMap: null,
	    	userCourses: null,
	    	currentPager: 1,
				sort: '-dateModified',
				isUpdating: false
	    };
		},
		
		navigatePager: function(dir) {
			var currentPager = this.state.currentPager,
					_this = this;
			currentPager += dir;
			_this.setState({
				currentPager: currentPager,
				isLoading: true,
			}, () => {
				this.retrieveMockExams();
			})
		},

 	render: function() {
    	var _this = this;
    	return (
		 	<div className="collections">
		        <div className="content-toolbar">
	          		<h3>Mock Exam Management</h3>
		        </div>
		        <div style={{"border": "1px solid #ddd", "padding": "10px"}}>
	          		<div className="collection-statuses">
		            	<div className="dp-table" style={{"tableLayout": "fixed", "width": "100%"}}>
		              	{
			                ADMIN_STATUSES.map(function(mode, index) {
			                  return (
			                    <div key={index} className={"dp-table-cell cell " + (_this.state.currentMode === mode ? 'active' : '')} onClick={_this.changeStatusMode.bind(_this, mode)}>
			                    {mode.title + ' (' + mode.count + ')'}
			                    </div>
			                  )
			                })
		              	}
		            	</div>
		          	</div>
	          		<hr/>
	          		{	
	          			!_this.state.isLoading &&
			            <ExamsTable
			            	data={this.state.collectionData}
			            	courses={this.state.userCourses}
										conceptsMap={this.state.conceptsMap}
										mode={this.state.currentMode}
										sort={this.state.sort}
										publishCollection={this.publishCollection}
										rejectCollection={this.rejectCollection}
										recoverCollection={this.recoverCollection}
										createNewVerCollection={this.createNewVerCollection}
										isUpdating={this.state.isUpdating}
										onSortChange={this.onSortChange}/> 
										
		          	}
		          	{
		          		// if this component is still loading data from server, show CircularProgress	
			            _this.state.isLoading &&
			            <CircularProgress />
								}
								<Pager>
									{
										_this.state.currentPager > 1 &&
										<Pager.Item
											onClick={_this.navigatePager.bind(_this, -1)}
											disabled={_this.state.currentPager === 1}
										>
											Previous
										</Pager.Item>
									}
									{' '}
									{
										_this.state.collectionData.length >= ITEM_LIMIT &&
										<Pager.Item
											onClick={_this.navigatePager.bind(_this, 1)}
											disabled={_this.state.collectionData.length < ITEM_LIMIT}
										>
											Next
										</Pager.Item>
									}
								</Pager>
		          	
		        </div>
      		</div>
    	)
	},
	countMockExamsInModeAll: function(){
		var _this = this;
		var count = ADMIN_STATUSES.length;
	    	// count number of mock-exam in each mode 
	    	_this.retrieveMockExams(function(){
	    		for (var i = 0; i < ADMIN_STATUSES.length; i++) {
	    		_this.countMockExamsInMode(ADMIN_STATUSES[i], function() {
	    			count--;
	    			if (count <= 0) _this.forceUpdate();
	    		});
	    	      }
	    	}); // loading mock-exams from server 
	    	
	},
	componentDidMount: function() {
		var _this = this;

	    this.setState({
      		isLoading: true,
      		statusMode: ADMIN_STATUSES,
					currentMode: ADMIN_STATUSES[0],
					currentPager: 1
	    }, function(){
	    	_this.countMockExamsInModeAll();
	    	this.retrieveMockExams(); // loading mock-exams from server 
	    	this.retrieveUserCourses(); // loading registered courses of user from server 
	    	this.retrieveConceptsMap(); // loading map of concepts from server 
	    })
  	},

});

export default ExamsManagement;		


/** WEBPACK FOOTER **
 ** ./src/components/Exam/ExamsManagement.js
 **/